/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Event_BeforeInputs */



/**
* | output |
* | --- |
* | "Insert event before" |
*
* @param {Insert_Event_BeforeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_event_before = /** @type {((inputs?: Insert_Event_BeforeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Event_BeforeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer un événement avant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge das Ereignis vor dem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci evento prima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте событие перед")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar evento antes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在插入事件之前")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前にイベントを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इससे पहले इवेंट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir evento antes")
	return /** @type {LocalizedString} */ ("Insert event before")
});